document.addEventListener('DOMContentLoaded', function() {
    const heartWrappers = document.querySelectorAll('.heart-wrapper');
  
    // Preload wishlist from localStorage
    let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
  
    heartWrappers.forEach(wrapper => {
      const productId = wrapper.dataset.id;
      const emptyIcon = wrapper.querySelector('.heart-empty');
      const filledIcon = wrapper.querySelector('.heart-filled');
  
      // Check if product is in wishlist and update icons accordingly
      const inWishlist = wishlist.some(item => item.id === productId);
      if (inWishlist) {
        // emptyIcon.style.display = 'none';
        filledIcon.style.display = 'block';
      } else {
        emptyIcon.style.display = 'block';
        // filledIcon.style.display = 'none';
      }
  
      wrapper.addEventListener('click', function() {
        const productData = {
          id: wrapper.dataset.id,
          handle: wrapper.dataset.handle,
          title: wrapper.dataset.title,
          image: wrapper.dataset.image,
          price: wrapper.dataset.price
        };
  
        const existingIndex = wishlist.findIndex(item => item.id === productData.id);
  
        const emptyIcon = wrapper.querySelector('.heart-empty');
        const filledIcon = wrapper.querySelector('.heart-filled');
  
        if (existingIndex === -1) {
          // Add to wishlist: hide empty, show filled
          wishlist.push(productData);
        //   emptyIcon.style.display = 'none';
          filledIcon.style.display = 'block';
        } else {
          // Remove from wishlist: show empty, hide filled
          wishlist.splice(existingIndex, 1);
          emptyIcon.style.display = 'block';
          filledIcon.style.display = 'none';
        }
        localStorage.setItem('wishlist', JSON.stringify(wishlist));
      });
    });
  });
  